export default __webpack_public_path__ + "static/media/Parent_Parties_BG.eaa65b46.jpg";